module.exports = __webpack_public_path__ + "img/download-btn-bg.5930d65e.png";